import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { MentalLinkIdentifier } from '../../types';
import MultipartLessonIndex from './MultipartLessonIndex';
import Modal from '../../components/Modal';
import LinkManager from '../../lib/LinkManager';
import MentalApi from '../../lib/MentalApi';
import MentalNotFound from '../../components/MentalNotFound';

interface WrapperMatchParams {
    mentalId: string,
    mentalSlug: string,
    lessonId: string,
    lessonSlug: string,
}

interface Props extends RouteComponentProps<WrapperMatchParams> {
}

// TODO: Farben berücksichtigen (vom Info-Fenster)

const MultipartLessonIndexWithData: React.FC<Props> = ({ match, history }: Props) => {
    const mentalLinkIdentifier: MentalLinkIdentifier = {
        mentalId: match.params.mentalId,
        mentalSlug: match.params.mentalSlug,
    };
    const { lessonId } = match.params;

    const lessonIndexLink = LinkManager.getMentalLessonIndexLink(mentalLinkIdentifier);
    const data = MentalApi.getMultipartLesson(mentalLinkIdentifier, lessonId);

    return (
        <Modal
            closeWindowCallback={() => history.push(lessonIndexLink)}
            modalClass="modal-full"
        >
            {data
                ? <MultipartLessonIndex multipartLesson={data} />
                : (
                    <MentalNotFound
                        what="Übung"
                    />
                )
            }
        </Modal>
    );
};

export default MultipartLessonIndexWithData;
